import React__default, { useState, useMemo } from 'react';
import { SwanCollectionContext } from './collection.context.js';

function CollectionContextProvider(props) {
    const { children  } = props;
    const [childItems, setChildItems] = useState([]);
    const contextValue = useMemo(()=>({
            childItems,
            setChildItems
        }), [
        childItems,
        setChildItems
    ]);
    return /*#__PURE__*/ React__default.createElement(SwanCollectionContext.Provider, {
        value: contextValue
    }, children);
}

export { CollectionContextProvider };
